module.exports = __webpack_public_path__ + "img/card-img-overlay.6977451e.jpg";